import http from "../lib/http";

export const getFlashSales = async () => {
  try {
    const response = await http.get("/api/customer/flash-sales");
    return response.data;
  } catch (error) {
    console.error("Error fetching flash sale products:", error);
    throw error;
  }
};